module.exports = __webpack_public_path__ + "static/media/peroni_terzo_tempo.1f39909f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/peroni_terzo_tempo.jpg
// module id = 810
// module chunks = 0